module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjBAMAAADs965qAAAAHlBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC3KG9qAAAACXRSTlMACz5AaJHa3P0bK12NAAAAT0lEQVQokWNgIBcIGaMCIwGGyploIIEBXWTmBAZUHgODJUGhyUDjIycwdKKb1cDggSYyw4E+rjeAG2SJRygYbvzgcj0IoDkVhxBNXE8UAAB8+McLF7hZQQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/fa-tasks.png
// module id = 3303
// module chunks = 0